import type { CVEditingSection, FullCV } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';
import SkillPill from './SkillPill';

interface SkillsProps {
  competences: FullCV['competences'];
  accent: string;
  onEdit?: (section: CVEditingSection) => void;
}

export default function Skills({ competences, accent, onEdit }: SkillsProps) {
  const { t } = useCVTranslation();
  const handleEdit = () => onEdit && onEdit('competences');
  const editable = onEdit !== undefined;

  if (!competences?.length && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable} accentColor={accent}>
      <div className="rounded-lg border p-2.5">
        <h2 className="text-[11px] font-black uppercase tracking-widest text-black">
          {t('CV.skills')}
        </h2>
        <ul className="mt-1 flex flex-wrap gap-2">
          {(competences ?? []).map((c, i) => (
            <SkillPill key={i} text={c} accent={accent} />
          ))}
        </ul>
      </div>
    </EditableSection>
  );
}
